import { GetFaqResult } from '../api';
import { AppErrorKeys } from '../errors/error';
import { getErrorResponse } from './common';

export const MOCK_FAQ_OK: GetFaqResult = {
  categories: [
    {
      order: 0,
      name: 'Inscription',
      questions: [
        {
          question: "Je ne suis pas inscrit(e) sur un restaurant. Comment accéder à l'application ?",
          answer:
            "L'application est exclusivement destinée aux salariés détenteurs d'un accès à l'un de nos restaurants. Vous pouvez vous inscrire si l'on vous a invité à le faire car vous êtes préalablement inscrit dans le restaurant d'entreprise.",
        },
        {
          question: "Erreur à l'inscription. Problème de réseau ?",
          answer:
            "Si vous réessayer lorsque vous avez du réseau et que vous n'arrivez toujours pas à vous inscrire, réessayer durant la journée pendant les heures d'ouverture.",
        },
        {
          question: "Comment se connecter si je n'arrive pas à réinitialiser mon mot de passe ?",
          answer:
            "Etes-vous bien inscrit en caisse avec vos prénoms et noms correctement orthographiés ? Avez-vous changé d'état civil dernièrement ? Si c'est le cas, demandez une mise à jour à votre responsable de restaurant.",
        },
        {
          question: 'Inscription en erreur. Déjà inscrit(e) précédemment ?',
          answer:
            "Si, vous n'arrivez pas à vous inscrire, vérifiez que vous n'êtiez pas déjà inscrit à l'application dans un précédent restaurant, le cas échéant essayez de vous connecter et désinscrivez-vous. ",
        },
        {
          question: "Aucun convive trouvé à l'inscription. Solde incorrect ?",
          answer: 'Assurez-vous que avez bien un badge de restaurant actif ou le dernier solde mis à jour avant de vous inscrire.',
        },
        {
          question: "Aucun convive trouvé à l'inscription. Que faire ?",
          answer: 'Assurez-vous que avez bien un badge de restaurant actif et que vous êtes bien inscrit en caisse. ',
        },
        {
          question: "Mon inscription n'aboutit pas. Comment sortir de l'impasse ?",
          answer:
            "Assurez-vous que votre solde est bien celui qui correspond à votre dernier ticket de caisse voir solde sur la machine à café si vous avez passé votre badge sur une borne. Si, vous n'arrivez toujours pas à vous inscrire,  adressez-vous à votre responsable de restaurant.",
        },
        {
          question: "J'ai fait un erreur à l'inscription. Que faire ?",
          answer: 'Connectez-vous, allez dans <b>Compte/Information</b> et désinscrivez-vous. Puis recommencer.',
        },
      ],
    },
    {
      order: 0,
      name: 'Mot de passe oublié',
      questions: [
        {
          question: "J'ai oublié mon mot de passe et je ne reçois aucun email. Pourquoi ?",
          answer:
            "Il est possible que l'email de regénération du mot de passe soit dans les indésirables de votre boîte de messagerie. Vérifiez.  \r\nIl arrive également que nos utilisateurs saisissent un autre email que celui avec lequel ils se sont inscrits initialement. Assurez-vous que vous saisissez le bon identifiant.",
        },
      ],
    },
    {
      order: 0,
      name: 'Connexion',
      questions: [
        {
          question: "J'avais un compte. Je suis parti(e) et revenu(e). Comment me reconnecter ?",
          answer:
            "Si vous arrivez à vous connecter, le système vous proposera sans doute de relier à nouveau votre compte aux nouvelles informations. \r\nSi ce n'est pas le cas, ou si le restaurant a changé, allez dans la rubrique <b>Compte</b>, puis <b>Informations</b> et désinscrivez-vous. Puis réinscrivez-vous à nouveau avec vos nouvelles informations.",
        },
        {
          question: 'Mon compte est bloqué ou en attente de fermeture. Comment accéder à mes fonctionnalités ?',
          answer:
            "Si vous vous connectez mais que vous ne pouvez pas recharger car votre compte est bloqué du fait d'un changement de badge, désinscrivez-vous. Attendez le mois suivant et inscrivez-vous avec votre nouveau profil de connexion valide. Pour tout autre cas, contactez votre responsable de restaurant.",
        },
        {
          question: "Comment se connecter si je n'arrive pas à réinitialiser mon mot de passe ?",
          answer:
            'Essayez de vous inscrire à nouveau avec un nouvel identifiant. Vous pourrez le changer ultérieurement. Si ça ne marche toujours pas, demander à votre responsable de restaurant de supprimer votre compte timechef et de vérifier que votre compte badge est correctement créé en caisse afin de pouvoir vous réinscrire à nouveau.',
        },
        {
          question: 'Je ne me souviens plus de mon identifiant. Comment puis-je me connecter ?',
          answer:
            'Essayez avec une aucune adresse email.  Si aucune de ces adresses ne fonctionne, inscrivez-vous à nouveau avec une autre adresse email. Sur certains sites, ce ne sera pas possible. Dans ce cas vous devrez vous adresser à votre Responsable de restaurant.',
        },
      ],
    },
  ],
};

export const MOCK_FAQ = {
  OK: MOCK_FAQ_OK,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};
